// custom dropdown
if (!customElements.get('custom-dropdown')) {
  class customDropDown extends HTMLElement {
    constructor() {
      super();

      this.dropDownBtn = this.querySelector('.el-dropdown-btn');
      this.listItems = this.querySelectorAll('li');
      this.closeBtns = document.querySelectorAll('.el-dropdown .closePop,.el-dropdown .overlay');
      this.init();
    }
    onClick = () => {
      this.dropDownBtn.addEventListener('click', (e) => {
        var dropDownList = e.currentTarget.nextElementSibling;
        dropDownList.classList.toggle('active');
      })
    }
    onSelect = () => {
      this.listItems.forEach(btn => {
        btn.addEventListener('click', (e) => {
          let that = e.currentTarget;
          let inputField = this.querySelector('input[type="hidden"]');
          that.closest('ul').querySelectorAll('li').forEach(input => input.classList.remove('active'));
          that.classList.add('active');
          inputField.value = that.getAttribute('value');
          inputField.dispatchEvent(new Event('change'));
        })
      })
    }
    closeBtn = () => {
      this.closeBtns.forEach(btn => {
        btn.addEventListener('click', (e) => {
          let that = e.currentTarget;
          that.closest('.el-dropdown').querySelector('.el-dropdown-list').classList.remove('active');
        })
      })
    }

    init = () => {
      this.onClick();
      this.onSelect();
      this.closeBtn();
    } 
  }
  customElements.define('custom-dropdown',customDropDown);
}

// plp pagination
const infiniteScroll = () => {
  let cacheCount = 0;
  window.addEventListener('scroll', () => {
      let infiniteWrapperEle = document.querySelector('[data-next-page]');
      if (infiniteWrapperEle) {
        let offsetBottom = infiniteWrapperEle.getBoundingClientRect().bottom - window.innerHeight;
        let rootMargin = window.innerHeight * 2;
        if (offsetBottom <= rootMargin && cacheCount == 0) {
            cacheCount++;
            let url = infiniteWrapperEle.dataset.nextPage;
            if (url != "") {
                fetch(url)
                .then(res => res.text())
                .then(data => {
                    cacheCount = 0;
                    var dataHTML = new DOMParser().parseFromString(data, 'text/html');
                    let productGrid = dataHTML.querySelector('[data-next-page]').innerHTML;
  
                    infiniteWrapperEle.insertAdjacentHTML("beforeend",productGrid);
  
                    infiniteWrapperEle.dataset.nextPage = dataHTML.querySelector('[data-next-page]').dataset.nextPage;
                    // window.history.pushState("Folkulture", "Folkulture", url);
                    if (window.AOS) { AOS.refreshHard() }
            })
        } else {
            document.querySelector('.pagination-loader').style.display = "none";
        }
        }   
      }
  })
}
// variant image on hover 
const pdpVariantImageHover = () => {
    let varTrigger = document.querySelectorAll('.variant-input.custom-product a');
    let targetEle = document.querySelector('.hover-featured-image');
    varTrigger.forEach(varBtn => {
      varBtn.addEventListener('mouseover', () => {
        targetEle.style.backgroundImage = `url(${varBtn.dataset.imgUrl})`;
        targetEle.style.opacity = 1;
    })
    varBtn.addEventListener('mouseleave', () => targetEle.style.opacity = 0)
  })
}
const removeCheckedFilters = () => {
  document.addEventListener('DOMContentLoaded', function () {
    // Get all filter checkboxes
    var checkboxes = document.querySelectorAll('.tag__input');

    // Add click event listener to each checkbox
    checkboxes.forEach(function (checkbox) {
      checkbox.addEventListener('click', function () {
        // Check if the clicked checkbox is already checked
        if (this.checked) {
          // Uncheck all other checkboxes
          checkboxes.forEach(function (otherCheckbox) {
            if (otherCheckbox !== checkbox) {
              otherCheckbox.checked = false;
            }
          });
        }
      });
    });
  });
}
window.addEventListener('DOMContentLoaded', () => {
  infiniteScroll();
  pdpVariantImageHover(); 
  removeCheckedFilters();
})